import axios from 'axios'
import queryString from 'query-string'

import {
  User
} from './models/User'
import {
  Channel,
  ChannelMessage,
} from './models/Channel'
import Workspace from './models/Workspace'
import Journal from './models/Journal'
import Subject from './models/Subject'
import {
  Material,
  MaterialCategory,
  MaterialGroup,
  MaterialType,
  MaterialAppearance,
  MaterialAppearancePart,
} from './models/Material'
import {
  FixedJournal,
  FixedJournalList,
} from './models/FixedJournal'

export default {
  async fetchCredentials(context) {
    const res = await axios.get('/api/credentials')
    context.state.credentials = res.data
    return res.data
  },
  async fetchAllUser(context) {
    const res = await axios.get('/api/users')
    User.insert({data: res.data})
    return res.data
  },
  async fetchAllChannel(context) {
    const res = await axios.get('/api/channels')
    Channel.insert({data: res.data})
    return res.data
  },
  async fetchAllChannelMessage(context, {channelId}) {
    const res = await axios.get(`/api/channels/${channelId}/messages`)
    const data = res.data.map(i => {
      i.channel_id = channelId
      return i
    })
    ChannelMessage.insert({data: data})
    return data
  },
  async fetchAllWorkspace(context, {channelId}) {
    const res = await axios.get(`/api/channels/${channelId}/workspaces`)
    const data = res.data.map(i => {
      i.channel_id = channelId
      return i
    })
    Workspace.insert({data})
    return data
  },
  async fetchWorkspace(context, {channelId, workspaceId}) {
    const res = await axios.get(`/api/channels/${channelId}/workspaces/${workspaceId}`)
    const data = {channel_id: channelId, ...res.data}
    Workspace.insert({data: [data]})
    return data
  },
  async fetchSubject(context, {channelId, workspaceId, subjectQuery}) {
    const res = await axios
      .get(`/api/channels/${channelId}/workspaces/${workspaceId}/subjects`, {
        params: subjectQuery,
        paramsSerializer(params) {
          return queryString.stringify(params)
        },
      })

    const data = res.data.map(i => {
      i.channel_id = channelId
      i.workspace_id = workspaceId
      return i
    })

    Subject.insert({data: data})

    return res.data
  },
  async fetchAllMaterialCategory(context, {channelId, workspaceId}) {
    const res = await axios.get(`/api/channels/${channelId}/workspaces/${workspaceId}/material-categories`)
    MaterialCategory.insert({data: res.data})
    return res.data
  },
  async fetchAllMaterialType(context, {channelId, workspaceId}) {
    const res = await axios.get(`/api/channels/${channelId}/workspaces/${workspaceId}/material-types`)
    MaterialType.insert({data: res.data})
    return res.data
  },
  async fetchAllMaterialGroup(context, {channelId, workspaceId}) {
    const res = await axios.get(`/api/channels/${channelId}/workspaces/${workspaceId}/material-groups`)
    const data = res.data.map(i => {
      [i.material_category_id, i.material_type_id] = i.id.split('.')
      return i
    })
    MaterialGroup.insert({data: data})
    return data
  },
  async fetchAllMaterialAppearance(context, {channelId, workspaceId}) {
    const res = await axios.get(`/api/channels/${channelId}/workspaces/${workspaceId}/material-appearances`)
    MaterialAppearance.insert({data: res.data})
    return res.data
  },
  async fetchAllMaterial(context, {channelId, workspaceId}) {
    const res = await axios.get(`/api/channels/${channelId}/workspaces/${workspaceId}/materials`)
    Material.insert({data: res.data})
    return res.data
  },
  async subscribeEvent(context, {channelId, workspaceId, params}) {
    const scheme = window.location.protocol === 'https:' ? "wss" : "ws"
    const host = window.location.host
    const path = `/ws/channels/${channelId}/workspaces/${workspaceId}/events`
    const qs = queryString.stringify(params)

    context.state.websocket = new WebSocket(`${scheme}://${host}${path}?${qs}`)

    context.state.websocket.addEventListener('message', e => {
      const msg = JSON.parse(e.data)
      const type = msg.type
      const data = msg.data

      switch (type) {
        case 'workspace.create':
        case 'workspace.update':
          Workspace.insertOrUpdate({data: {
            channel_id: channelId,
            ...data
          }})
          break
        case 'subject.create':
        case 'subject.update':
          Subject.insertOrUpdate({data: {
            channel_id: channelId,
            workspace_id: workspaceId,
            ...data
          }})
          break
        case 'subject.delete':
          Subject.delete(data.id)
          break
        case 'material.create':
        case 'material.update':
          Material.insertOrUpdate({data: {
            channel_id: channelId,
            workspace_id: workspaceId,
            ...data
          }})
          break
        case 'material.delete':
          Material.delete(data.id)
          break
        case 'material_category.create':
        case 'material_category.update':
          MaterialCategory.insertOrUpdate({data: {
            channel_id: channelId,
            workspace_id: workspaceId,
            ...data
          }})
          break
        case 'material_category.delete':
          MaterialCategory.delete(data.id)
          break
        case 'material_group.create':
          const [material_category_id, material_type_id] = data.id.split('.')
          MaterialGroup.insertOrUpdate({data: {
            channel_id: channelId,
            workspace_id: workspaceId,
            material_category_id,
            material_type_id,
            ...data
          }})
          break
        case 'material_group.delete':
          MaterialGroup.delete(data.id)
          break
        case 'channel_message.create':
        case 'channel_message.update':
          ChannelMessage.insertOrUpdate({data: {channel_id: channelId, ...data}})
          break
        case 'channel_message.delete':
          ChannelMessage.delete(data.id)
          break
      }
    })
  },
  async unsubscribeEvent({state}) {
    if (state.websocket && state.websocket.readyState === 1) {
      state.websocket.close()
    }
  },
  async clearSubject(context) {
    Subject.deleteAll()
  },
  async clearMaterialCategory(context) {
    MaterialCategory.deleteAll()
  },
  async clearMaterialType(context) {
    MaterialType.deleteAll()
  },
  async clearMaterialGroup(context) {
    MaterialGroup.deleteAll()
  },
  async clearMaterialAppearance(context) {
    MaterialAppearance.deleteAll()
    MaterialAppearancePart.deleteAll()
  },
  async clearMaterial(context) {
    Material.deleteAll()
  },
  async loadCredentials(context) {
    await context.dispatch('fetchCredentials')
  },
  async loadChannel(context) {
    await context.dispatch('fetchAllChannel')
    for (const i of context.getters.channels) {
      await context.dispatch('fetchAllWorkspace', {channelId: i.id})
    }
  },
  async loadWorkspace(context, {channelId, workspaceId}) {
    context.dispatch('fetchWorkspace', {channelId, workspaceId})
    context.dispatch('fetchAllMaterial', {channelId, workspaceId})
    context.dispatch('fetchAllMaterialCategory', {channelId, workspaceId})
    context.dispatch('fetchAllMaterialType', {channelId, workspaceId})
    context.dispatch('fetchAllMaterialGroup', {channelId, workspaceId})
    context.dispatch('fetchAllMaterialAppearance', {channelId, workspaceId})
    context.dispatch('fetchAllChannelMessage', {channelId})
    context.dispatch('fetchAllFixedJournalList', {channelId})
  },
  async unloadWorkspace(context) {
    context.dispatch('clearSubject')
    context.dispatch('clearMaterialAppearance')
    context.dispatch('clearMaterialGroup')
    context.dispatch('clearMaterialType')
    context.dispatch('clearMaterialCategory')
    context.dispatch('clearMaterial')
  },
  async onairWorkspace(context, workspace) {
    const res = await axios.put(`/api/channels/${workspace.channel_id}/workspaces/${workspace.id}/onair`)
    Workspace.update({where: [workspace.channel_id, workspace.id], data: {onair: true}})
  },
  async standbyWorkspace(context, workspace) {
    const res = await axios.delete(`/api/channels/${workspace.channel_id}/workspaces/${workspace.id}/onair`)
    Workspace.update({where: [workspace.channel_id, workspace.id], data: {onair: false}})
  },
  async setWorkspaceConfig(context, {channelId, workspaceId, key, value}) {
    const res = await axios.put(`/api/channels/${channelId}/workspaces/${workspaceId}/config/${key}`, JSON.stringify(value))
    await context.dispatch('fetchWorkspace', { channelId, workspaceId })
  },
  async updateWorkspace(context, workspace) {
    const res = await axios.patch(`/api/channels/${workspace.channel_id}/workspaces/${workspace.id}`, {
      name: workspace.name,
      default_material_category_id: workspace.default_material_category_id,
      default_material_appearance_id: workspace.default_material_appearance_id,
    })
    Workspace.update({where: workspace.id, data: res.data})
  },
  async withdrawSubject(context, {channelId, workspaceId, subjectId}) {
    const res = await axios.put(`/api/channels/${channelId}/workspaces/${workspaceId}/subjects/${subjectId}/withdrawal`)
    Subject.update({where: subjectId, data(i) { i.withdrawal = true }})
  },
  async unwithdrawSubject(context, {channelId, workspaceId, subjectId}) {
    const res = await axios.delete(`/api/channels/${channelId}/workspaces/${workspaceId}/subjects/${subjectId}/withdrawal`)
    Subject.update({where: subjectId, data(i) { i.withdrawal = false }})
  },
  async acceptSubject(context, {channelId, workspaceId, subjectId, materialGroupId}) {
    await axios.post(`/api/channels/${channelId}/workspaces/${workspaceId}/subjects/${subjectId}/accept`, {
      material_group_id: materialGroupId
    })
  },
  async createMaterial(context, {channelId, workspaceId, materialInput}) {
    const res = await axios.post(`/api/channels/${channelId}/workspaces/${workspaceId}/materials`, materialInput)
    Material.insert({data: [res.data]})
  },
  async batchCreateMaterialOrdered(context, {channelId, workspaceId, materialInputs}) {
    const res = await axios.post(`/api/channels/${channelId}/workspaces/${workspaceId}/batch/materials`, materialInputs)
    Material.insert({data: res.data})
  },
  async deleteMaterial(context, {channelId, workspaceId, materialId}) {
    const res = await axios.delete(`/api/channels/${channelId}/workspaces/${workspaceId}/materials/${materialId}`)
    Material.delete(materialId)
  },
  async hideMaterial(context, {channelId, workspaceId, materialId}) {
    const res = await axios.put(`/api/channels/${channelId}/workspaces/${workspaceId}/materials/${materialId}/hide`)
    Material.update({where: materialId, data(i) { i.hidden = true }})
  },
  async showMaterial(context, {channelId, workspaceId, materialId}) {
    const res = await axios.delete(`/api/channels/${channelId}/workspaces/${workspaceId}/materials/${materialId}/hide`)
    Material.update({where: materialId, data(i) { i.hidden = false }})
  },
  async batchUpdateMaterial(context, { channelId, workspaceId, data }) {
    const res = await axios.patch(`/api/channels/${channelId}/workspaces/${workspaceId}/materials`, data)
    Material.insertOrUpdate({data: res.data})
  },
  async updateJournal(context, {channelId, workspaceId, journal}) {
    const res = await axios.patch(`/api/channels/${channelId}/workspaces/${workspaceId}/journals/${journal.id}`, {
      text: journal.text,
      meta: journal.meta
    })
    Journal.update({where: journal.id, data: res.data})
  },
  async createChannelMessage(context, {channelId, channelMessageInput}) {
    const res = await axios.post(`/api/channels/${channelId}/messages`, {
      text: channelMessageInput.text,
      meta: channelMessageInput.meta
    })
    ChannelMessage.insertOrUpdate({data: {channel_id: channelId, ...res.data}})
  },
  async updateChannelMessage(context, {channelId, channelMessageId, channelMessageInput}) {
    const res = await axios.patch(`/api/channels/${channelId}/messages/${channelMessageId}`, {
      text: channelMessageInput.text,
      meta: channelMessageInput.meta
    })
    ChannelMessage.insertOrUpdate({data: {channel_id: channelId, ...res.data}})
  },
  async deleteChannelMessage(context, {channelId, channelMessageId}) {
    const res = await axios.delete(`/api/channels/${channelId}/messages/${channelMessageId}`)
    ChannelMessage.delete(channelMessageId)
  },
  async createMaterialCategory(context, {channelId, workspaceId, materialCategoryInput}) {
    const res = await axios.post(`/api/channels/${channelId}/workspaces/${workspaceId}/material-categories`, {
      id: materialCategoryInput.id,
      name: materialCategoryInput.name,
      meta: materialCategoryInput.meta,
    })
    MaterialCategory.insertOrUpdate({data: {channel_id: channelId, workspace_id: workspaceId, ...res.data}})
  },
  async updateMaterialCategory(context, {channelId, workspaceId, materialCategoryId, materialCategoryInput}) {
    const res = await axios.patch(`/api/channels/${channelId}/workspaces/${workspaceId}/material-categories/${materialCategoryId}`, materialCategoryInput)
    MaterialCategory.insertOrUpdate({data: {channel_id: channelId, workspace_id: workspaceId, ...res.data}})
  },
  async deleteMaterialCategory(context, {channelId, workspaceId, materialCategoryId}) {
    await axios.delete(`/api/channels/${channelId}/workspaces/${workspaceId}/material-categories/${materialCategoryId}`)
    MaterialCategory.delete(materialCategoryId)
  },
  async createMaterialGroup(context, {channelId, workspaceId, materialGroupInput}) {
    const res = await axios.post(`/api/channels/${channelId}/workspaces/${workspaceId}/material-groups`, materialGroupInput)
    const [material_category_id, material_type_id] = res.data.id.split('.')
    MaterialGroup.insertOrUpdate({data: {channel_id: channelId, workspace_id: workspaceId, material_type_id, material_type_id, ...res.data}})
  },
  async fetchUser(context, {userId}) {
    const res = await axios.get(`/api/users/${userId}`)
    User.insertOrUpdate({data: res.data})
  },
  async createUser(context, { id, name, organization, department }) {
    const res = await axios.post(`/api/users`, { id, name, organization, department })
    User.insertOrUpdate({data: res.data})
  },
  async updateUser(context, {userId, userInput}) {
    const res = await axios.patch(`/api/users/${userId}`, userInput)
    User.update({where: userId, data: res.data})
  },
  async deleteUser(context, { userId }) {
    await axios.delete(`/api/users/${userId}`)
    User.delete(userId)
  },
  async appendUserRole(context, { userId, channelId, roleType }) {
    const res = await axios.put(`/api/users/${userId}/roles/${channelId}`, {type: roleType})
    await context.dispatch('fetchUser', { userId })
  },
  async removeUserRole(context, { userId, channelId }) {
    const res = await axios.delete(`/api/users/${userId}/roles/${channelId}`)
    await context.dispatch('fetchUser', { userId })
  },
  async updateMePassword(context, {userId, oldPassword, newPassword}) {
    try {
      const res = await axios.post(`/api/me/password`, {old_password: oldPassword, new_password: newPassword})
    } catch(err) {
      switch (err.response.data.code) {
        case 'INCORRECT_PASSWORD':
          return 'いまのパスワードが間違っています'
          break
        default:
          return 'エラーが発生してます'
      }
    }
    await context.dispatch('fetchUser', { userId })
  },
  async fetchAllFixedJournalList(context, {channelId, needToRefreshAll = true}) {
    const res = await axios.get(`/api/channels/${channelId}/fixed-journal-lists`)
    FixedJournalList.insert({data: res.data.data}) // todo fixed-journals なぜ data.data にしないとうまくいかないのか？ backendでミスってる？
    if (needToRefreshAll) {
      // FIXME: 定型文の順番を入れ替えた時に内容を全部取得する必要はないため、分岐を生やした。これでいいのかはわからない
      for (const l of context.getters.fixedJournalLists) {
        await context.dispatch('fetchAllFixedJournal', {channelId, fixedJournalListId: l.id})
      }
    }
    return res.data.data
  },
  async fetchAllFixedJournal(context, {channelId, fixedJournalListId}) {
    const res = await axios.get(`/api/channels/${channelId}/fixed-journal-lists/${fixedJournalListId}/fixed-journals`)
    FixedJournal.insert({data: res.data.data})
    return res.data.data
  },
  async createFixedJournalList(context, {channelId, fixedJournalListInput}) {
    const res = await axios.post(`/api/channels/${channelId}/fixed-journal-lists`, fixedJournalListInput)
    // todo fixed-journals 以下は流儀に反すると思う. backend の Schema Output 辺りがまだ理解できていない
    res.data['channel_id'] = channelId
    FixedJournalList.insert({data: res.data})
  },
  async updateFixedJournalList(context, {channelId, fixedJournalListId, fixedJournalListInput, hasToUpdateTime = true}) {
    const res = await axios.patch(
      `/api/channels/${channelId}/fixed-journal-lists/${fixedJournalListId}`,
      fixedJournalListInput, {
        params: {hasToUpdateTime: hasToUpdateTime},
      })
    FixedJournalList.insertOrUpdate({data: {channel_id: channelId, ...res.data}})
  },
  async batchUpdateFixedJournalList(context, { channelId, data }) {
    const res = await axios.patch(`/api/channels/${channelId}/fixed-journal-lists`, data)
    // backendのschemaでchannel_idを含める方法が分からなかったため、ここでレスポンスに含める
    res.data.forEach((i) => {i.channel_id = channelId})
    FixedJournalList.insertOrUpdate({data: res.data})
  },
  async deleteFixedJournalList(context, {channelId, fixedJournalListId}) {
    const res = await axios.delete(`/api/channels/${channelId}/fixed-journal-lists/${fixedJournalListId}`)
    FixedJournalList.delete([channelId, fixedJournalListId])
  },
  async createFixedJournal(context, {channelId, fixedJournalListId, fixedJournalInput}) {
    const res = await axios.post(`/api/channels/${channelId}/fixed-journal-lists/${fixedJournalListId}/fixed-journals`, fixedJournalInput)
    // todo fixed-journals 以下は流儀に反すると思う. backend の Schema Output 辺りがまだ理解できていない
    res.data['channel_id'] = channelId
    res.data['fixed_journal_list_id'] = fixedJournalListId
    FixedJournal.insert({data: res.data})
    // 以下、単一の定型文リストの更新日時を取得することが目的だが、APIエンドポイントが存在しないため、暫定でこうしている
    await context.dispatch('fetchAllFixedJournalList', {channelId})
  },
  async updateFixedJournal(context, {channelId, fixedJournalListId, fixedJournalId, fixedJournalInput}) {
    const res = await axios.patch(`/api/channels/${channelId}/fixed-journal-lists/${fixedJournalListId}/fixed-journals/${fixedJournalId}`, fixedJournalInput)
    FixedJournal.insertOrUpdate({data: {channel_id: channelId, fixed_journal_list_id: fixedJournalListId, ...res.data}})
    // 以下、単一の定型文リストの更新日時を取得することが目的だが、APIエンドポイントが存在しないため、暫定でこうしている
    await context.dispatch('fetchAllFixedJournalList', {channelId})
  },
  async batchUpdateFixedJournal(context, { channelId, fixedJournalListId, data }) {
    const res = await axios.patch(`/api/channels/${channelId}/fixed-journal-lists/${fixedJournalListId}/fixed-journals`, data)
    res.data.forEach((i) => {
      // backendのschemaでchannel_idを含める方法が分からなかったため、ここでレスポンスに含める
      i.channel_id = channelId
      i.fixed_journal_list_id = fixedJournalListId
      // FixedJournalListのように配列で insertOrUpdate では期待通り順序変更できないのでいったん削除して追加する
      FixedJournal.delete([channelId, fixedJournalListId, i.id])
      FixedJournal.insert({data: i})
    })
    // 以下、単一の定型文リストの更新日時を取得することが目的だが、APIエンドポイントが存在しないため、暫定でこうしている
    await context.dispatch('fetchAllFixedJournalList', {channelId, needToRefreshAll: false})
  },
  async deleteFixedJournal(context, {channelId, fixedJournalListId, fixedJournalId}) {
    const res = await axios.delete(`/api/channels/${channelId}/fixed-journal-lists/${fixedJournalListId}/fixed-journals/${fixedJournalId}`)
    FixedJournal.delete([channelId, fixedJournalListId, fixedJournalId])
    // 以下、単一の定型文リストの更新日時を取得することが目的だが、APIエンドポイントが存在しないため、暫定でこうしている
    await context.dispatch('fetchAllFixedJournalList', {channelId})
  },
}
